import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { Stamp, Text } from 'pcln-design-system'
import { EarlyBird, Discount, Timer, SplitTicket, Calendar } from 'pcln-icons'

const MerchandisingSection = styled(Text)`
  line-height: 14px;
  font-size: 10px;
  margin: auto 0;

  ${(props) => props.theme.flyQueries.tabletlg} {
    font-size: 12px;
    line-height: 24px;
  }
`

const StyledStamp = styled(Stamp)`
  vertical-align: middle;
  font-size: 10px;
  margin-right: 5px;
  ${(props) => props.theme.flyQueries.tabletlg} {
    font-size: 12px;
  }
`

const ShortTextTablet = styled(Text)`
  display: none;
  ${(props) => props.theme.flyQueries.tabletlg} {
    display: inline;
  }
`

const ShortTextDesktop = styled(Text)`
  display: none;
  ${(props) => props.theme.flyQueries.desktoplg} {
    display: inline;
  }
`

const iconStyling = `
  height: 18px;
  width: 18px;
  @media (min-width: 375px) {
    height: 24px;
    width: 24px;
  }
`

const Icons = {
  earlyBird: styled(EarlyBird)`
    ${iconStyling}
  `,
  discount: styled(Discount)`
    ${iconStyling}
  `,
  timer: styled(Timer)`
    ${iconStyling}
  `,
  splitTicket: styled(SplitTicket)`
    ${iconStyling}
  `,
  calendar: styled(Calendar)`
    ${iconStyling}
  `,
}

export default function MerchandisingStamp({ icon, info, details, hasTravelBadge }) {
  const Icon = get(Icons, `[${icon}]`, null)
  const ShortText = hasTravelBadge ? ShortTextDesktop : ShortTextTablet
  return (
    <MerchandisingSection>
      <StyledStamp color={'alert.base'} data-test={'merchandising-stamp'}>
        {Icon && <Icon mr={'2px'} />}
        {info}
      </StyledStamp>
      <ShortText data-test={'merchandising-details-text'} color={'text.base'} hasTravelBadge={hasTravelBadge}>
        {details}
      </ShortText>
    </MerchandisingSection>
  )
}

MerchandisingStamp.propTypes = {
  icon: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  details: PropTypes.string,
  hasTravelBadge: PropTypes.bool,
}
